import { Component, ElementRef, EventEmitter, HostBinding, OnInit, ViewChild, HostListener, Input, Output, Directive, Renderer2 } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { AlertPopup, config, HttpLoader, path } from 'app/app.config';
import { SocketService } from 'app/socket/socket.service';
import { ELibraryService } from '../../e-library.service';
import { saveAs as importedSaveAs } from 'file-saver';
import { DatePipe } from '@angular/common';
import { AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { FileValidationService } from 'app/shared/file-validation.service';
// import { EventEmitter } from 'protractor';
import { AppComponent } from 'app/app.component';
import { ELibraryDetailsComponent } from '../e-library-details.component';
import { ELibraryComponent } from '../../e-library.component';
import { DataSharingService } from 'app/shared/data-sharing.service';
import * as moment from 'moment'
import { ValidationService } from 'app/components/form-validation/validation.service';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { ConfirmationDialogService } from 'app/confirmation-dialog/confirmation-dialog.service';
import { HttpErrorResponse } from '@angular/common/http';
import { ChatService } from 'app/components/chat-list/chat.service';
import { LlmService } from 'app/services/llm.service';


export interface QuestionType {
  value: string;
  viewValue: string;
}

// @Directive()
@Component({
  selector: 'app-e-library-upload',
  templateUrl: './e-library-upload.component.html',
  styleUrls: ['./e-library-upload.component.scss']
})
export class ELibraryUploadComponent implements OnInit {

  @Input() classFileList;
  @Input() selectedClassList;
  @Input() maxLength: number = 400;
  @Input() maxHeight = '4rem';
  @Input() isChecked = false;
  @Input() isSelected = false;
  @Input() isSelectedDoc;
  isModelType: any;
  @Output() onElibraryCountUpdate: EventEmitter<any> = new EventEmitter<any>();
  @Output() getChange = new EventEmitter();

  @ViewChild('scrollframe') scrollFrame: ElementRef;
  @ViewChild('durationInput') durationInput: ElementRef;
  @HostListener('document:click', ['$event'])
  onDocumentClick(event) {
    this.show = false;
  }

  clickit($event, ind) {
    $event.stopPropagation();
    this.dropdownIndex = ind;
    this.show = !this.show;
  }

  show = false;
  // event:string;
  dropdownIndex: any;

  OFFSET: number = config.DEFAULT_OFFSET;
  RECORD_LIMIT = config.DEFAULT_RECORD_LIMIT;
  modalScrollDistance = config.DEFAULT_SCROLL_DIST;
  modalScrollThrottle = config.SCROLL_THROTTLE;
  activeUrl: string;
  uploadFileForm: FormGroup;
  radioSel: any;
  radioSelected: string;
  radioSelectedString: string;
  isShown = []; // hidden by default
  isUploadDocLoader = false;


  /** Chat File Size limit */
  chatFileSizeLimit: number = config.MAX_ATTACH_FILE_SIZE;
  chatFileExt = config.TOPIC_EXT;

  upLoadedFileList: any[] = [];
  uploadWatermarkLogo: any[] = [];
  fileDuration: string = '';
  selectedRadio = true;
  getElibraryFileList: any[] = [];
  fileUploadingInProgress = false;
  preUploadedFile: any;
  preUploadedWatermarkFile: any;
  preProfileUrl = path.PRE_PROFILE_URL;
  profileUrl = path.PROFILE_URL;
  selectedClass = {};
  selectedOptions: any[] = [];
  selectOption: any;
  private _prevSelected: any;
  isMarkEmpty = false;
  isQuestionEmpty = false;
  myChecked = 0;
  assementError = false;
  priceValidate = false;
  priceErrMsg = "";
  discountValidate = false;
  uploadUrl: string = '';

  attachedFileSizeLimit: number = config.MAX_ATTACH_FILE_SIZE;
  attachFileExt = config.ATTACHMENT_EXT;

  public subscribers: any = {};
  showPaginationSpinner = false;
  showBtnSpinner = false;
  checkCorrectAns = false;

  /** View Variables */
  domElementControl = {
    showCreateNewQuestions: false,
    showCreateNewSurQuestion: false,
    showCreateNewPolQuestion: false,
    showCreateNewNotesQuestion: false
  };
  fieldArray: Array<any> = [];
  optionArray = [];
  surveyoptionArray = [];
  pollQuestOptionArray = [];
  questionnariesList = [];
  newAttribute: any = {};
  newOption: any = {};
  firstField = true;
  isPublish = false;
  isDownload = false;
  isAllowRetest: boolean = false;

  group_id: any = "";
  is_question_found = false;
  is_survey_found = false;
  is_polls_found = false;
  is_notes_found = false;
  surveyQuestionEnable = false;
  pollQuestionEnable = false;
  correct = 0;
  selectedOption = [];
  myVideos = [];

  uploadFileIcons = [
    { name: "pdf", icons: '../../../../assets/images/file_types/pdf.png' },
    { name: "doc", icons: '../../../../assets/images/file_types/doc.png' },
    { name: "docx", icons: '../../../../assets/images/file_types/docx.png' },
    { name: "txt", icons: '../../../../assets/images/file_types/txt.png' },
    { name: "ppt", icons: '../../../../assets/images/file_types/ppt.png' },
    { name: "pptx", icons: '../../../../assets/images/file_types/ppt.png' },
    { name: "pptm", icons: '../../../../assets/images/file_types/ppt.png' },
    { name: 'mp3', icons: '../../../../assets/images/file_types/mp3.png' },
    { name: 'mp4', icons: '../../../../assets/images/file_types/mp4.png' },
    { name: 'wav', icons: '../../../../assets/images/file_types/png.png' },
    { name: 'avi', icons: '../../../../assets/images/file_types/png.png' },
    { name: 'png', icons: '../../../../assets/images/file_types/png.png' },
    { name: 'jpeg', icons: '../../../../assets/images/file_types/jpg.png' },
    { name: 'jpg', icons: '../../../../assets/images/file_types/jpg.png' },
    { name: 'html', icons: '../../../../assets/images/file_types/html.png' },
    { name: 'psd', icons: '../../../../assets/images/file_types/psd.png' },
    { name: 'json', icons: '../../../../assets/images/file_types/json.png' },
    { name: 'xlsx', icons: '../../../../assets/images/file_types/xlsx.png' },
    { name: 'xls', icons: '../../../../assets/images/file_types/xls.png' },
    { name: 'css', icons: '../../../../assets/images/file_types/css.png' },
    { name: 'zip', icons: '../../../../assets/images/file_types/zip.png' },
    { name: 'xml', icons: '../../../../assets/images/file_types/xml.png' }
  ];

  RadioOptions = [
    { name: 'Assessment Test', value: 'AT' },
    { name: 'Survey', value: 'S' },
    { name: 'Poll', value: 'P' }
  ];

  file_download = [
    { name: 'Yes', value: true },
    { name: 'No', value: false }
  ];

  publish = [
    { title: 'Yes', value: true },
    { title: 'No', value: false }
  ]

  questions: QuestionType[] = [
    { value: "choice", viewValue: "Choice" },
    // { value: "text", viewValue: "Text" },
    // { value: "Rating", viewValue: "Rating" }
  ];

  defaultChecked = 'AT';
  checked = false;
  pub_article = false;
  public selectedField: number = 0
  public selId: string;
  type: any;


  editorConfig: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: 'auto',
    // minHeight: '0',
    maxHeight: '95px',
    width: 'auto',
    minWidth: '0',
    translate: 'yes',
    enableToolbar: true,
    showToolbar: true,
    placeholder: 'Enter Description....',
    defaultParagraphSeparator: '',
    defaultFontName: '',
    defaultFontSize: '',
    fonts: [
      { class: 'arial', name: 'Arial' },
      { class: 'times-new-roman', name: 'Times New Roman' },
      { class: 'calibri', name: 'Calibri' },
      { class: 'comic-sans-ms', name: 'Comic Sans MS' }
    ],
    uploadWithCredentials: false,
    sanitize: true,
    toolbarPosition: 'top',
    toolbarHiddenButtons: [
      [
        'undo',
        'redo',
        'strikeThrough',
        'subscript',
        'superscript',
        'heading',
      ],
      [
        'textColor',
        'backgroundColor',
        'customClasses',
        'link',
        'unlink',
        'insertImage',
        'insertVideo',
        'insertHorizontalRule',
        'removeFormat',
      ]
    ]
  };

  editorNotesConfig: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: '10rem',
    minHeight: '5rem',
    maxHeight: 'auto',
    width: 'auto',
    minWidth: '0',
    translate: 'yes',
    enableToolbar: true,
    showToolbar: true,
    placeholder: 'Enter notes here...',
    defaultParagraphSeparator: '',
    defaultFontName: '',
    defaultFontSize: '',
    fonts: [
      { class: 'arial', name: 'Arial' },
      { class: 'times-new-roman', name: 'Times New Roman' },
      { class: 'calibri', name: 'Calibri' },
      { class: 'comic-sans-ms', name: 'Comic Sans MS' }
    ],
    //   customClasses: [
    //   {
    //     name: 'quote',
    //     class: 'quote',
    //   },
    //   {
    //     name: 'redText',
    //     class: 'redText'
    //   },
    //   {
    //     name: 'titleText',
    //     class: 'titleText',
    //     tag: 'h1',
    //   },
    // ],
    // uploadUrl: 'v1/image',
    uploadWithCredentials: false,
    sanitize: true,
    toolbarPosition: 'top',
    toolbarHiddenButtons: [
      [
        'undo',
        'redo',
        'strikeThrough',
        'subscript',
        'superscript',
        'indent',
        'outdent',
        // 'insertUnorderedList',
        // 'insertOrderedList',
        'heading',
      ],
      [
        'textColor',
        'backgroundColor',
        'customClasses',
        'link',
        'unlink',
        'insertImage',
        'insertVideo',
        'insertHorizontalRule',
        'removeFormat',
        'toggleEditorMode'
      ]
    ]
  };

  fileLLMformData: FormData = new FormData();
  llmfile_uuid: any = "";
  generateAIQuest: any = "";

  summarization: string = "";
  summary_category: any[] = [];
  summary_metadata: any = {};
  userRole: any;
  activeTab: string = "lesson";
  questionTopic: string;
  isActiveStepper: boolean = false;
  message_id: any;
  stepperIndex: number = 0;
  trainLLM: boolean = false;
  Lesson_responseData: any;
  isTrainingLLM: boolean = false;
  is_trainned_success: boolean = false;
  constructor(
    private alert: AlertPopup,
    private httpLoader: HttpLoader,
    private router: Router,
    private route: ActivatedRoute,
    private socketService: SocketService,
    private chatService: ChatService,
    private elibraryService: ELibraryService,
    private fb: FormBuilder,
    private fileValidationService: FileValidationService,
    private appComponent: AppComponent,
    private elibraryDetailsComponent: ELibraryDetailsComponent,
    private elibraryComponent: ELibraryComponent,
    private dataSharingService: DataSharingService,
    // private validationService: ValidationService
    private confirmDialogService: ConfirmationDialogService,
    private llmService: LlmService,
    private renderer: Renderer2
  ) {
    this.uploadFileForm = fb.group({
      title: ['', Validators.compose([Validators.required, ValidationService.noWhiteSpaceTitleValidator])],
      description: [''],
      duration: [''],
      price: [''],
      discount: [''],
      watermark_title: [''],
      download_link: [''],
      publish: [''],
      assessment: this.fb.array([]),
      survey: this.fb.array([]),
      polls: this.fb.array([]),
      notes: this.fb.array([]),
      min_percentage: ['', [Validators.required]],
      is_allow_retest: [''],
      random_question: ['', [Validators.required]]
    });

    this.getSelecteditem();
  }

  ngOnInit(): void {
    this.route.paramMap.subscribe(x => {
      this.group_id = x.get('id');
    });
    this.userRole = parseInt(this.appComponent.userDetail['user_role']);
    this.questionTopic = '';
  }
  /*
    chooseUploadFilellm(event){
      const files = event.target.files[0];
      const formData = new FormData();
      formData.append('client_id',localStorage.getItem('company_id'));
      formData.append('file', files,files.name);
      this.elibraryService.uploadLLMPdf(formData).subscribe((res:any)=>{
          this.alert.showAlertMessage(res);
      });
    } */

  getSelecteditem() {
    this.radioSel = this.questions.find(Item => Item.value === this.radioSelected);
    this.radioSelectedString = JSON.stringify(this.radioSel);
  }

  getFileIcon() {
    return this.uploadFileIcons.find(
      f => f.name === this.upLoadedFileList[0]?.mimeType
    );
  }


  openTab(evt, tabName) {
    this.activeTab = tabName;
    var i, x, tablinks;
    x = document.getElementsByClassName("content-tab");
    for (i = 0; i < x.length; i++) {
      x[i].style.display = "none";
    }
    tablinks = document.getElementsByClassName("tab");
    for (i = 0; i < x.length; i++) {
      tablinks[i].className = tablinks[i].className.replace(" is-active", "");
    }
    document.getElementById(tabName).style.display = "flex";
    evt.currentTarget.className += " is-active";
  }

  keyDownHandler(event) {
    if (event.keyCode === 32 && event.target.selectionStart === 0) {
      return false;
    }
  }

  numericOnlyHandler(e) {
    if (String.fromCharCode(e.keyCode).match(/[^0-9]/g)) {
      this.alert.showAlertMessage({ message: 'Please enter number value only' });
      return false;
    }

  }


  assQuestion(): FormArray {
    return this.uploadFileForm.get('assessment') as FormArray;
  }

  assQuestAnswers(questIndex: number): FormArray {
    return this.assQuestion().at(questIndex).get('answer') as FormArray;
  }

  newAssQuestion(): FormGroup {
    return this.fb.group({
      question: [null, Validators.compose([Validators.required, this.noWhitespaceValidator])],
      answer: this.fb.array([]),
      mark: ['', Validators.compose([Validators.required, Validators.min(1)])],
      answer_type: [''],
      question_type: ['']
    })
  }

  newAssAnswers(): FormGroup {
    return this.fb.group({
      answer: [null, Validators.compose([Validators.required, this.noWhitespaceValidator])],
      is_correct_answer: [false]
    })
  }

  onCreateAssQuestion() {
    this.domElementControl.showCreateNewQuestions = true;
    this.is_question_found = true;
    let assessmentValue = this.uploadFileForm.get('assessment').value;


    if (assessmentValue.length > 0) {
      let lastIndex = assessmentValue[assessmentValue.length - 1];
      if (lastIndex.answer_type === 'choice') {
        var checked = false;
        var IsChecked = false;
        for (let i = 0; i < lastIndex.answer.length; i++) {
          const correctAnswer = lastIndex.answer[i];

          if (lastIndex.question !== null && lastIndex.mark !== null && correctAnswer.answer !== null && correctAnswer.is_correct_answer !== false) {
            checked = true;
            this.assementError = true;
            this.assQuestion().push(this.newAssQuestion());
            // this.assQuestAnswers(this.assQuestion().length - 1).push(this.newAssAnswers());
            return;
          }
        }

        if (!checked) {
          this.assementError = false;
          this.alert.showAlertMessage({ message: "Please select the correct answer." });
          return false;
        }
      } else {
        this.assementError = true;
        if (lastIndex.question !== null && lastIndex.answer_type !== null) {
          this.assQuestion().push(this.newAssQuestion());
          checked = true;
        }

        if (!checked) {
          this.assementError = false;
          this.alert.showAlertMessage({ message: "Please select the correct answer." });
          return false;
        }
      }
    } else {
      this.assementError = true;
      this.assQuestion().push(this.newAssQuestion());
      // this.assQuestAnswers(this.assQuestion().length - 1).push(this.newAssAnswers());
    }
  }

  onSelectedType(questions, questIndex) {

    let control = <FormArray>this.uploadFileForm.controls.assessment;

    control.value[questIndex]['answer_type'] = questions.value;

    this.isSelected = true;

    if (questions.value == 'choice') {
      this.isShown[questIndex] = true;
      this.radioSelectedString = questions.value;
      if (this.assQuestAnswers(questIndex).length == 0) {
        this.assQuestAnswers(questIndex).push(this.newAssAnswers());
      }

    } else if (questions.value == 'text') {
      this.isShown[questIndex] = false;
      control.at(questIndex).get('mark').clearValidators();
      this.assQuestAnswers(questIndex).clear();
    }
  }


  onCreateAssOption(questIndex: number) {
    this.assQuestAnswers(questIndex).push(this.newAssAnswers());
  }

  oncheckedOptions(event, options, questIndex, optionIndex) {

    let control = <FormArray>this.uploadFileForm.controls.assessment;

    let answer = control.value[questIndex].answer;


    for (let index = 0; index < answer.length; index++) {

      if (index === optionIndex) {
        answer[index].is_correct_answer = true;
        this.checkCorrectAns = false;
      } else {
        answer[index].is_correct_answer = false;
      }
    }

    let removeIdx = this.assQuestAnswers(questIndex).value;

    var checked = false;
    for (let i = 0; i < removeIdx.length; i++) {
      const correctAnswer = removeIdx[i];
      if (correctAnswer.is_correct_answer !== false) {
        checked = true;
        this.selectedOptions[questIndex] = false;
        // let button = document.querySelector('.disabledBtn');
        //   button.removeAttribute('disabled');
      }
    }

    let checker = removeIdx => removeIdx.every(v => v.is_correct_answer !== false);

    if (checker && checked) {
      // let button = document.querySelector('.disabledBtn');
      //     button.removeAttribute('disabled');
      this.uploadFileForm.markAsDirty();
    }
    this.uploadFileForm.updateValueAndValidity();
  }


  removeAssQuestion(questIndex) {
    this.assQuestion().removeAt(questIndex);
  }

  removeAssOptions(questIndex, optionIndex) {
    this.assQuestAnswers(questIndex).removeAt(optionIndex);

    let removeIdx = this.assQuestAnswers(questIndex).value;

    var checked = false;
    for (let i = 0; i < removeIdx.length; i++) {
      const correctAnswer = removeIdx[i];
      if (correctAnswer.is_correct_answer !== false) {
        checked = true;
      }
    }

    if (!checked) {
      this.selectedOptions[questIndex] = true;
      this.alert.showAlertMessage({ message: 'Please select the correct answer.' });
      let button = document.querySelector('.disabledBtn');
      button.setAttribute('disabled', 'disabled');
      return false;
    }


  }


  /***Survey create questions */

  surveyQuestions(): FormArray {
    return this.uploadFileForm.get('survey') as FormArray;
  }

  surveyOptions(questIndex: number): FormArray {
    return this.surveyQuestions().at(questIndex).get('answer') as FormArray;
  }

  newSurveyQuestion(): FormGroup {
    return this.fb.group({
      question: ['', Validators.compose([Validators.required, this.noWhitespaceValidator])],
      answer: this.fb.array([]),
      question_type: ['survey']
    })
  }

  onCreateSurveyQuestion() {
    this.domElementControl.showCreateNewSurQuestion = true;
    this.is_survey_found = true;
    this.surveyQuestions().push(this.newSurveyQuestion());
    this.surveyOptions(this.surveyQuestions().length - 1).push(this.newSurveyOptions());
  }

  onRemoveSurveyQuestion(questIndex) {
    this.surveyQuestions().removeAt(questIndex);
  }

  newSurveyOptions(): FormGroup {
    return this.fb.group({
      answer: ['', Validators.compose([Validators.required, this.noWhitespaceValidator])]
    })
  }

  oncreateSurveyOptions(questIndex: number) {
    this.surveyOptions(questIndex).push(this.newSurveyOptions());
  }

  clearFormArray(formArray: FormArray) {
    while (formArray.length !== 0) {
      formArray.removeAt(0);
    }
  }


  removeSurveyOptions(questIndex, choiceIndex) {
    this.surveyOptions(questIndex).removeAt(choiceIndex);

  }

  /***Poll create questions */
  pollQuestions(): FormArray {
    return this.uploadFileForm.get('polls') as FormArray
  }

  pollChoices(questIndex: number): FormArray {
    return this.pollQuestions().at(questIndex).get('answer') as FormArray
  }

  newPollQuestion(): FormGroup {
    return this.fb.group({
      question: ['', Validators.compose([Validators.required, this.noWhitespaceValidator])],
      answer: this.fb.array([]),
      question_type: ['polls']
    })
  }

  onCreatePollQuestion() {
    this.domElementControl.showCreateNewPolQuestion = true;
    this.is_polls_found = true;
    this.pollQuestions().push(this.newPollQuestion());
    this.pollChoices(this.pollQuestions().length - 1).push(this.newPollChoice());
  }

  newPollChoice(): FormGroup {
    return this.fb.group({
      answer: ['', Validators.compose([Validators.required, this.noWhitespaceValidator])]
    })
  }

  onCreatePollChoice(questIndex: number) {
    this.pollChoices(questIndex).push(this.newPollChoice());
  }

  removePollQuestion(index) {
    this.pollQuestions().removeAt(index);
  }

  removePollChoice(questIndex, choiceIndex) {
    this.pollChoices(questIndex).removeAt(choiceIndex);
  }

  enabledSurveyQuestion() {
    this.surveyQuestionEnable = !this.surveyQuestionEnable;
  }

  enablePollQuestions() {
    this.pollQuestionEnable = !this.pollQuestionEnable;
  }


  hideFileUploadModal(data?: any): void {
    if (data) {
      this.removeFileFromList(data);
    }

    const details = this.elibraryDetailsComponent;

    details.activeFileUpload = false;
    details.activeFileUploadHeader = false;
    details.activeTileView = true;

    this.elibraryComponent.viewLibraryList = false;

    this.uploadFileForm?.reset();
    this.preUploadedFile = null;
    this.showBtnSpinner = false;
  }


  /****notes */
  notesQuestions(): FormArray {
    return this.uploadFileForm.get('notes') as FormArray;
  }

  createNotesQuestion(): FormGroup {
    return this.fb.group({
      question: ['', Validators.compose([Validators.required, this.noWhitespaceValidator])],
      question_type: ['notes']
    });
  }

  onCreateNotesQuestion() {
    this.domElementControl.showCreateNewNotesQuestion = true;
    this.is_notes_found = true;
    this.notesQuestions().push(this.createNotesQuestion());

  }

  removeNotesQuestion(index) {
    this.notesQuestions().removeAt(index);
  }

  async fileValidationHanlder(files) {
    try {
      const isValidate = await this.fileValidationService.fileValidation(files, this.chatFileExt, this.chatFileSizeLimit);
      return files;
    } catch (err) {
      err.map(li => {
        const errMsg = {
          message: li
        };
        // this.alert.showAlertMessage(errMsg);
        this.alert.showAlertMessage({ message: 'The file is too large and cannot be uploaded. Please reduce the size of the file and try again (max 1GB)' });
      });
      return false;
    }
  };

  // async chooseUploadFile(event) {
  //   const files = event.target.files;
  //   const fileSizeInBytes = files[0].size;

  //   // console.log(`File size: ${fileSizeInBytes} bytes`);

  //   // Optional: Convert to KB or MB for better readability
  //   const fileSizeInKB = fileSizeInBytes / 1024;
  //   const fileSizeInMB = fileSizeInBytes / (1024 * 1024);
  //   const fileSizeInGB = fileSizeInMB / (1024 * 1024 * 1024);
  //   // console.log(`File size: ${fileSizeInKB.toFixed(2)} KB`);
  //   // console.log(`File size: ${fileSizeInMB.toFixed(2)} MB`);
  //   // console.log(`File size: ${fileSizeInGB.toFixed(2)} GB`);
  //   const file_gb = fileSizeInGB.toFixed(2);
  //   const size = file_gb.split(".")[1].substring(0, 1);
  //   if (parseInt(size) > 0) {
  //     this.alert.showAlertMessage({ "message": "File size is too large" });
  //     return;
  //   }

  //   if (this.userRole == 1 || this.userRole == 2) {
  //     if (files[0].type == "application/pdf" || files[0].type.indexOf("application/msword") != -1 || files[0].type.indexOf("application/vnd.openxmlformats") != -1) {
  //       if (this.isSelectedDoc['model_type'] === 1) {
  //         this.fileLLMformData = new FormData();
  //         this.fileLLMformData.append('class_id', this.group_id);
  //         this.fileLLMformData.append('file', files[0], files[0].name);
  //       } else {
  //         this.fileLLMformData = new FormData();
  //         this.fileLLMformData.append('class_id', this.group_id);
  //         this.fileLLMformData.append('file', files[0], files[0].name);
  //         this.fileLLMformData.append('document_type', 'standard');
  //         this.fileLLMformData.append('mode', 'assessment')
  //       }
  //     }
  //   }

  //   const vidData = files[0].type.split("/");
  //   if (vidData[0] === 'video' || vidData[0] === 'audio') {
  //     let video = document.createElement(vidData[0]);

  //     const vid = await this.onloadVideo(files[0], video);

  //     var sec = vid['duration'];
  //     var h, m, s, result = '';
  //     // HOURs
  //     h = Math.floor(sec / 3600);
  //     sec -= h * 3600;
  //     if (h) {
  //       result = h < 10 ? '0' + h + ':' : h + ':';
  //     }
  //     // MINUTEs
  //     m = Math.floor((sec % 3600) / 60);
  //     sec -= m * 60;
  //     result += m < 10 ? '0' + m + ':' : m + ':';
  //     // SECONDs
  //     s = Math.floor((sec % 3600) % 60);
  //     result += s < 10 ? '0' + s : s;
  //     var videoDuration = result;
  //     this.uploadFileForm.patchValue({
  //       duration: videoDuration
  //     })
  //   }

  //   const fileValid = await this.fileValidationHanlder(files);
  //   if (fileValid) {
  //     this.concatFileIntoArray(files);
  //   }
  // };

  async chooseUploadFile(event) {
    const files = event.target.files;

    if (!files || files.length === 0) return;

    const file = files[0];
    const fileSizeInBytes = file.size;

    // Convert sizes
    const fileSizeInKB = fileSizeInBytes / 1024;
    const fileSizeInMB = fileSizeInKB / 1024;
    const fileSizeInGB = fileSizeInMB / 1024;

    // Limit file size to 1GB
    if (fileSizeInGB >= 1) {
      this.alert.showAlertMessage({ message: "File size is too large" });
      return;
    }

    // Allowed document types
    const allowedDocs = [
      "application/json",
      "application/pdf",
      "application/msword",
      "application/vnd.openxmlformats-officedocument"
    ];

    if (this.userRole == 1 || this.userRole == 2) {
      const fileType = file.type;

      if (
        fileType === "application/pdf" ||
        fileType.includes("application/msword") ||
        fileType.includes("application/vnd.openxmlformats") ||
        fileType.includes("application/json")
      ) {

        this.fileLLMformData = new FormData();
        this.fileLLMformData.append("class_id", this.group_id);
        this.fileLLMformData.append("file", file, file.name);

      }
    }

    // Handle video/audio duration
    const typeParts = file.type.split("/");

    if (typeParts[0] === "video" || typeParts[0] === "audio") {
      const mediaElement = document.createElement(typeParts[0]);

      const vid: any = await this.onloadVideo(file, mediaElement);
      let sec = vid.duration;

      const h = Math.floor(sec / 3600);
      sec -= h * 3600;

      const m = Math.floor(sec / 60);
      sec -= m * 60;

      const s = Math.floor(sec);

      const videoDuration =
        (h ? String(h).padStart(2, "0") + ":" : "") +
        String(m).padStart(2, "0") +
        ":" +
        String(s).padStart(2, "0");

      this.uploadFileForm.patchValue({
        duration: videoDuration
      });
    }

    const fileValid = await this.fileValidationHanlder(files);

    if (fileValid) {
      this.concatFileIntoArray(files);
    }
  }


  onloadVideo(files, video) {

    return new Promise((resolve, reject) => {
      try {
        video.preload = 'metadata';

        video.onloadedmetadata = function () {
          resolve(this)
        }
        video.src = window.URL.createObjectURL(files);
      } catch (event) {
        reject(event)
      }
    });
  }

  async chooseWatermarkLogo(event) {
    const watermark = event.target.files;
    const logofileValid = await this.fileValidationHanlder(watermark);
    if (logofileValid) {
      this.concatLogoFileIntoArray(watermark);
    }
  }

  get isAssessmentEmpty(): boolean {
    return this.assQuestion().controls.length === 0;
  }



  concatFileIntoArray(files) {
    if (files && files.length > 0) {

      if (this.upLoadedFileList.length < 1) {
        const fileObject = {
          user_id: null,
          group_id: null,
          files: []
        };
        const paramId = +this.route.snapshot.paramMap.get('id');
        let fileEl = null;
        let existFileList = null;
        for (let i = 0; i < files.length; i++) {
          const splitArr = files[i].name.split('.');
          files[i].mimeType = splitArr[splitArr.length - 1].toLowerCase();
          files[i].uniqId = Date.now();
          existFileList = [...this.appComponent.selectedFilesList];
          fileEl = existFileList.find(el => el.group_id === paramId);
          if (fileEl) {
            fileEl.files.unshift(files[i]);
            this.upLoadedFileList = fileEl.files;

            if (files[i].mimeType === 'pdf' || files[i].mimeType === 'docx' || files[i].mimeType === 'doc' || files[i].mimeType === 'ppt' || files[i].mimeType === 'pptx' || files[i].mimeType === 'txt' || files[i].mimeType === 'xml') {
              this.uploadFileForm.patchValue({
                duration: ''
              });
              this.renderer.setStyle(this.durationInput.nativeElement, 'display', 'none');
            }

          } else {
            fileObject.group_id = paramId;
            fileObject.files.push(files[i]);
            this.upLoadedFileList = fileObject.files;
            existFileList.unshift(fileObject);
          }
        }
        this.appComponent.selectedFilesList = existFileList;
      } else {
        this.alert.showAlertMessage({
          message: 'File seletion limit reached.'
        });
      }
    }
  };

  concatLogoFileIntoArray(watermark) {
    if (watermark && watermark.length > 0) {
      if (this.uploadWatermarkLogo.length < 1) {
        const fileObject = {
          user_id: null,
          group_id: null,
          files: []
        };
        const paramId = +this.route.snapshot.paramMap.get('id');
        let fileEl = null;
        let existFileList = null;
        for (let i = 0; i < watermark.length; i++) {
          const splitArr = watermark[i].name.split('.');
          watermark[i].mimeType = splitArr[splitArr.length - 1].toLowerCase();
          watermark[i].uniqId = Date.now();
          existFileList = [...this.appComponent.selectedFilesList];
          fileEl = existFileList.find(el => el.group_id === paramId);
          if (fileEl) {
            fileEl.files.unshift(watermark[i]);
            this.uploadWatermarkLogo = fileEl.files;
          } else {
            fileObject.group_id = paramId;
            fileObject.files.push(watermark[i]);
            this.uploadWatermarkLogo = fileObject.files;
            existFileList.unshift(fileObject);
          }
        }
        this.appComponent.selectedFilesList = existFileList;
      } else {
        this.alert.showAlertMessage({
          message: 'File seletion limit reached.'
        });
      }
    }
  }

  /** Remove files from selected list */
  removeFileFromList(val: any[]): void {
    if (!val || val.length === 0) return;

    const data = val[0];

    if (!this.upLoadedFileList?.length) return;

    const currentFiles = this.upLoadedFileList.filter(
      file => file.uniqId !== data.uniqId
    );

    const paramId = Number(this.route.snapshot.paramMap.get('id'));

    const existFileList = this.appComponent.selectedFilesList || [];
    const fileGroup = existFileList.find(el => el.group_id === paramId);

    if (fileGroup) {
      fileGroup.files = currentFiles;
    }

    this.upLoadedFileList = currentFiles;
    this.appComponent.selectedFilesList = existFileList;
  }

  removeFileFromLogoList(val) {
    const data = val[0];
    if (this.uploadWatermarkLogo.length > 0) {
      const newLogoFileList = this.uploadWatermarkLogo;
      const currentFiles = newLogoFileList.filter(f1 => f1.uniqId !== data.uniqId);
      const paramId = +this.route.snapshot.paramMap.get('id');
      let fileE1 = null;
      const existFileList = this.appComponent.selectedFilesList;
      fileE1 = existFileList.find(el => el.group_id === paramId);
      if (fileE1) {
        fileE1.files = currentFiles;
      }
      this.uploadWatermarkLogo = currentFiles;
      this.appComponent.selectedFilesList = existFileList;
    }
  }

  createNewFileData() {

    this.uploadFileForm.updateValueAndValidity();
    console.log("this.uploadFileForm", this.uploadFileForm);
    if (this.uploadFileForm.controls['min_percentage'].invalid) {
      this.alert.showAlertMessage({ "message": "Please enter minimum mark required." });
      return;
    }
    if (this.uploadFileForm.controls['random_question'].invalid) {
      this.alert.showAlertMessage({ message: 'Please enter random question number value.' });
      return;
    }
    let formVal = this.uploadFileForm.value;
    if (this.isActiveStepper) {
      if (this.llmfile_uuid) {
        this.sendMessageFile(formVal, true);
      } else {
        this.sendMessageFile(formVal, false);
      }
    } else {
      if (this.fileLLMformData.get("file") && this.fileLLMformData.get("class_id") && (this.userRole == 1 || this.userRole == 2)) {
        this.confirmDialogService.openConfirmDialog('', {
          title: 'Confirmation',
          message: 'Do you want to train the LLM?',
          btnOkText: 'YES',
          btnCancelText: 'NO',
          onClose: (data: any) => {
            this.isUploadDocLoader = true;
            if (data) {
              this.sendMessageFile(formVal, true);
            } else {
              this.sendMessageFile(formVal, false);

            }
          }
        });

      } else {
        this.sendMessageFile(formVal, false);
        this.isUploadDocLoader = false;
      }

    }

    // this.sendMessageFile(formVal);
  }

  removeUploadFile(data) {
    try {
      this.removeFileFromList(data)
      // this.upLoadedFileList = [];
      this.preUploadedFile = null;
      this.fileDuration = null;
      this.durationInput.nativeElement.value = '';
    } catch (error) {
      console.log(error);
    }
  }

  removeWatermarkLogo(data) {
    try {
      this.removeFileFromLogoList(data);
      this.preUploadedWatermarkFile = null;
    } catch (error) {
      console.log(error);
    }
  }

  public noWhitespaceValidator(control: FormControl) {
    const isWhitespace = (control.value || '').trim().length === 0;
    const isValid = !isWhitespace;
    return isValid ? null : { 'whitespace': true };
  }

  public isNumberKey(evt: any) {
    var charCode = (evt.which) ? evt.which : evt.keyCode
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      // this.discountValidate = true;
      this.alert.showAlertMessage({ message: 'Please enter discount in numbers only. For example 10% or 15%' });
      // this.priceErrMsg = 'Please enter discount number only. For example 535';
      return false;
    } else {
      // this.discountValidate = false;
      return;
    }
  }

  discountPercentage(evt) {
    let discount = evt.target.value;
    if (discount > 100) {
      this.alert.showAlertMessage({ message: 'Please enter discount min 1% to max 100%' });
      return false
    } else {
      return;
    }
  }



  public numberOnlyValidator(event: any) {

    var numberValue = event.target.value;
    if ((event.which != 46 || numberValue.indexOf('.') != -1) && (event.which < 48 || event.which > 57)) {
      if ((event.which != 46 || numberValue.indexOf('.') != -1)) {
        this.alert.showAlertMessage({ message: 'Please enter a price in numbers only and two numbers allowed after the decimal point. For example: 523 or 523.36' });
      }
      event.preventDefault();
    }
  }


  IsDecimalValue(el) {
    var ex = /^\s*\d*\.?\d{0,2}\s*$/;

    if (ex.test(el.target.value) === false) {
      el.target.value = el.target.value.substring(0, el.target.value.length - 1);
      // this.alert.showAlertMessage({message: 'Price enter two numbers only allowed after decimal point'})
    }
    if (ex.test(el.target.value) === false) {
      el.target.value = '';
    }
  }

  sendMessageFile(data, trainLLM) {

    if (!this.upLoadedFileList?.length || this.fileUploadingInProgress) {
      return;
    }

    this.showBtnSpinner = true;

    if (!this.validateAssessment(data)) {
      this.showBtnSpinner = false;
      return;
    }

    const formFields = this.prepareFormFields(data, trainLLM);

    if (trainLLM && this.isLLMAllowed()) {
      this.handleLLMTraining(formFields);
    } else {
      this.uploadFile(formFields);
    }
  }

  isLLMAllowed(): boolean {

    if (!this.fileLLMformData) return false;

    const file = this.fileLLMformData.get('file');
    const classId = this.fileLLMformData.get('class_id');

    if (!file || !classId) {
      return false;
    }

    return this.userRole === 1 || this.userRole === 2;
  }


  handleLLMTraining(formFields: any) {
    // Show loader / spinner
    this.httpLoader.showLoader();
    this.showBtnSpinner = true;

    // Check if stepper mode is active
    if (this.isActiveStepper) {
      formFields['is_doc_section'] = true;
      formFields['summary'] = this.summarization || '';
      formFields['llmfile_uuid'] = this.llmfile_uuid;

      // Upload file with progress
      this.appComponent.fileUploadWithProgess(formFields, this.upLoadedFileList)
        .then((fileList: any) => {
          this.handleUploadSuccess(fileList, formFields);
        })
        .catch(error => this.handleUploadError(error));

    } else {
      // Stepper not active: do separate LLM upload and summarization
      this.uploadLLMFileAndSummarize(formFields);
    }
  }

  private uploadLLMFileAndSummarize(formFields: any) {
    // Upload LLM PDF to train model
    this.elibraryService.uploadLLMPdf(this.fileLLMformData)
      .subscribe({
        next: (res: any) => {
          this.llmfile_uuid = res.document_info.uuid;
          this.alert.showAlertMessage({ message: "LLM Model Trained Successfully" });
        },
        error: (err: HttpErrorResponse) => {
          this.alert.showAlertMessage({ message: err.error?.error || 'LLM training failed' });
        }
      });

    // Upload summary PDF
    this.elibraryService.uploadSummaryPdf(this.fileLLMformData)
      .subscribe({
        next: (res: any) => {
          const extractText = res.result;

          const payload = {
            query: `summary of text "${extractText}"`,
            client_id: localStorage.getItem('company_id')
          };

          // Get summarized text from API
          this.elibraryService.getSummarize(payload)
            .subscribe({
              next: (sumRes: any) => {
                this.summarization = sumRes.result.answer || '';
                formFields['summary'] = this.summarization;
                formFields['llmfile_uuid'] = this.llmfile_uuid;

                // Upload file with progress
                this.appComponent.fileUploadWithProgess(formFields, this.upLoadedFileList)
                  .then((fileList: any) => this.handleUploadSuccess(fileList, formFields))
                  .catch(error => this.handleUploadError(error));
              },
              error: () => {
                // If summarization fails, still upload
                formFields['summary'] = '';
                this.appComponent.fileUploadWithProgess(formFields, this.upLoadedFileList)
                  .then((fileList: any) => this.handleUploadSuccess(fileList, formFields))
                  .catch(error => this.handleUploadError(error));
              }
            });
        },
        error: (err: HttpErrorResponse) => {
          this.alert.showAlertMessage({ message: err.error?.error || 'Summary upload failed' });
        }
      });
  }

  validateAssessment(data): boolean {

    if (!data.assessment?.length) return true;

    for (const q of data.assessment) {

      if (q.answer_type === 'choice') {
        const hasAnswer = q.answer.some(a => a.is_correct_answer);

        if (!hasAnswer) {
          this.alert.showAlertMessage({
            message: "Please select a correct answer"
          });
          return false;
        }
      }

      if (!q.question || !q.answer_type) {
        this.alert.showAlertMessage({
          message: "Invalid assessment question"
        });
        return false;
      }
    }

    if (!data.random_question) {
      this.alert.showAlertMessage({
        message: "Enter random question number"
      });
      return false;
    }

    if (data.random_question > data.assessment.length) {
      this.alert.showAlertMessage({
        message: "Random question exceeds question count"
      });
      return false;
    }

    return true;
  }

  prepareFormFields(data, trainLLM) {

    const userid = parseInt(localStorage.getItem('user_id'));

    const classList = this.selectedClassList.filter(x => x !== userid);

    return {
      message: data.title,
      assessment: JSON.stringify(data.assessment),
      survey: JSON.stringify(data.survey),
      polls: JSON.stringify(data.polls),
      notes: JSON.stringify(data.notes),
      group_id: this.group_id,
      chat_user_list: classList,
      fieldName: 'group_gallery',
      activity: 'groupChatMessage',
      price: parseFloat(data.price) || 0,
      discount: parseInt(data.discount) || 0,
      random_question: parseInt(data.random_question) || 0,
      is_llm_training: trainLLM,
      is_doc_section: true
    };
  }

  uploadFile(formFields: any) {
    this.fileUploadingInProgress = true;

    this.appComponent
      .fileUploadWithProgess(formFields, this.upLoadedFileList)
      .then((fileList: any) => {
        this.handleUploadSuccess(fileList, formFields); // pass formFields
      })
      .catch(error => {
        this.handleUploadError(error);
      });
  }

  handleUploadSuccess(fileList: any, formFields: any) {
    this.fileUploadingInProgress = false;
    this.llmfile_uuid = "";

    const file = fileList[0];
    const newData = {
      created_at: file.day,
      download_url: file.download_file_path,
      file_ext: file.file_ext,
      file_id: file.file_id,
      message: file.message,
      message_id: file.message_id,
      file_type: file.file_type,
      shared_by: file.first_name,
      is_llm_training: formFields.is_llm_training,
      summary: formFields.summary || '',
      is_doc_section: true
    };

    this.elibraryDetailsComponent.getElibraryFileList = [
      newData,
      ...this.elibraryDetailsComponent.getElibraryFileList
    ];

    // Emit updated lesson count
    const elibraryCount = { count: 1, group_id: this.group_id };
    this.onElibraryCountUpdate.emit(elibraryCount);

    console.log(elibraryCount, 'elib');


    this.dataSharingService.emitLessonCount(elibraryCount);

    this.resetUploadUI();
    this.alert.showAlertMessage({ message: 'Assessment created successfully.' });
  }

  handleUploadError(error) {

    this.fileUploadingInProgress = false;
    this.showBtnSpinner = false;

    this.alert.showAlertMessage(error.error);

    this.resetUploadUI();
  }

  resetUploadUI() {

    this.uploadFileForm.reset();
    this.showBtnSpinner = false;

    this.elibraryComponent.getElibrary(0);

    this.elibraryDetailsComponent.domElementControl.showCreateElibrary = false;
    this.elibraryDetailsComponent.activeFileUpload = false;
    this.elibraryDetailsComponent.activeTileView = true;
  }


  Continue() {
    this.isActiveStepper = true;
    this.questionTopic = "";
    if (this.stepperIndex == 0) {
      if (this.fileLLMformData.get("file") && this.fileLLMformData.get("class_id") && (this.userRole == 1 || this.userRole == 2)) {
        this.confirmDialogService.openConfirmDialog('', {
          title: 'Confirmation',
          message: 'Do you want to train the LLM?',
          btnOkText: 'YES',
          btnCancelText: 'NO',
          onClose: (data: any) => {
            this.isUploadDocLoader = true;
            if (data) {
              this.trainLLM = true;
              this.StepFormLLM();
            } else {
              this.trainLLM = false;
              this.StepFormLLM();

            }
          }
        });
      } else {
        this.trainLLM = false;
        this.isUploadDocLoader = false;
        this.StepFormLLM();
      }
    } else {
      this.newLessonCreate();
    }

  }

  Stepback() {
    if (this.stepperIndex >= 2) {
      this.stepperIndex = this.stepperIndex - 1;
    }

    switch (this.stepperIndex) {
      case 1:
        this.activeTab = 'assessment';
        break;
      case 2:
        this.activeTab = 'survey';
        break;
      case 3:
        this.activeTab = 'poll';
        break;
      case 4:
        this.activeTab = 'notes';
    }

    console.log("steperindex", this.stepperIndex);
    let tabName = this.activeTab;
    var i, x, tablinks;
    x = document.getElementsByClassName("content-tab");
    for (i = 0; i < x.length; i++) {
      x[i].style.display = "none";
    }
    tablinks = document.getElementsByClassName("tab");
    for (i = 0; i < x.length; i++) {
      tablinks[i].className = tablinks[i].className.replace(" is-active", "");
    }
    document.getElementById(tabName).style.display = "flex";
    const myElement = document.getElementById(tabName);

    // Add a single class
    myElement.classList.add('is-active');
    tablinks[this.stepperIndex].className = tablinks[this.stepperIndex].className + " is-active";

  }


  GenerateQuestion() {

    let payLoad = {
      "client_id": Number(localStorage.getItem("company_id")),
      "class_id": Number(this.group_id),
      "document_uuid": this.generateAIQuest,
      // "topic":this.questionTopic,
      "num_questions": 10
    };
    this.isTrainingLLM = true;
    this.showBtnSpinner = true;
    this.uploadFileForm.controls['assessment'] = this.fb.array([]);
    this.uploadFileForm.get('assessment').reset();
    this.llmService.llmQuestionGeneratebyDoc(payLoad).subscribe({
      next: (response: any) => {
        this.isTrainingLLM = false;
        this.showBtnSpinner = false;

        if (response?.questions?.length) {

          const assessmentArray =
            this.uploadFileForm.get('assessment') as FormArray;

          assessmentArray.clear();
          this.isShown = [];

          response.questions.forEach((ass: any, questionIndex: number) => {

            const question: FormGroup = this.newAssQuestion();

            const isChoice =
              ass.answer_type === 'multiple_choice' ||
              ass.answer_type === 'single_choice';

            const isQuestion =
              ass.question_type === 'multiple_choice' ||
              ass.question_type === 'single_choice';



            // Patch only non-array fields
            question.patchValue({
              question: ass.question,
              answer_type: isChoice ? 'choice' : ass.answer_type,
              mark: ass.mark,
              question_type: 'question'
            });

            const answers = ass.answer || ass.answers || [];

            answers.forEach((opt: any) => {
              const answerGroup = this.fb.group({
                answer: [opt?.answer ?? ''],
                is_correct_answer: [!!opt?.is_correct_answer]
              });

              this.getAnswerArray(question).push(answerGroup);
            });

            // Show options UI if choice
            this.isShown[questionIndex] = isChoice;

            assessmentArray.push(question);
          });


          this.uploadFileForm.get('min_percentage')?.setValue(5);
          this.uploadFileForm.get('random_question')
            ?.setValue(assessmentArray.length);

          this.uploadFileForm.markAsDirty();
          this.uploadFileForm.markAllAsTouched();
          this.uploadFileForm.updateValueAndValidity();
        }
      },

      error: () => {
        this.showBtnSpinner = false;
        this.isTrainingLLM = false;

        this.alert.showAlertMessage({ message: 'Please try again' });

        const assessmentArray =
          this.uploadFileForm.get('assessment') as FormArray;

        assessmentArray.clear();
      }
    });




    /*  this.elibraryService.getAssessmentQuestions(payLoad).subscribe((result:any)=>{
              this.isTrainingLLM = false;
            if(result['result']['questions'].length > 0){
              let LLM_questions = result['result']['questions'].filter((ques:any)=>ques.answer_type=="choice");
              if(LLM_questions.length > 0){
               LLM_questions.forEach((ass:any,questionIndex:any) => {

                   const question: FormGroup = this.newAssQuestion();
                    question.patchValue(ass);
                    ass.answer.forEach((opt) => {
                      const answer:FormGroup = this.fb.group({
                          answer: new FormControl(opt['answer']),
                          is_correct_answer: new FormControl(opt['is_correct_answer'])
                      });
                      if(opt['is_correct_answer']){
                        // this.selectedOptions[questionIndex]=true;
                      }

                    // answer.patchValue(opt);
                      if(ass['answer_type']=="choice"){
                        this.isShown[questionIndex]=true;
                        // this.radioSelectedString = ass;
                      }
                      (question.get("answer") as FormArray).insert(questionIndex,answer);

                    });

                   // this.assQuestion().push(question);

                    (this.uploadFileForm.controls['assessment'] as FormArray).push(question)
                  });
                  this.uploadFileForm.controls['min_percentage'].setValue(5);
                  this.uploadFileForm.controls['random_question'].setValue(this.uploadFileForm.controls['assessment'].value.length);
                  this.uploadFileForm.markAsDirty();
                  this.uploadFileForm.markAllAsTouched();
                  this.uploadFileForm.markAsPristine();
                  this.uploadFileForm.updateValueAndValidity();
              }

            }
      },(error:HttpErrorResponse)=>{
        this.showBtnSpinner = false;
         this.isTrainingLLM = false;
         this.alert.showAlertMessage({"message":"Please enter valid assessment topic"});
      }); */
  }

  onRetestChange(event: any) {

  }

  getAnswerArray(question: FormGroup): FormArray {
    return question.get('answer') as FormArray;
  }

  onKeypressEvent(event: any) {
    this.questionTopic = event.target.value;
  }

  // StepFormLLM() {

  //   if (this.trainLLM && this.fileLLMformData.get("file") && this.fileLLMformData.get("class_id") && (this.userRole == 1 || this.userRole == 2)) {
  //     this.showBtnSpinner = true;
  //     this.isTrainingLLM = true;
  //     // this.elibraryService.uploadLLMPdf(this.fileLLMformData).subscribe((res:any)=>{
  //     //    this.llmfile_uuid = res['document_info']['uuid'];
  //     //   this.alert.showAlertMessage({"message":"LLM Model Trained Successfully"});
  //     //  },(error:HttpErrorResponse)=>{
  //     //   this.isTrainingLLM = false;
  //     //    this.alert.showAlertMessage({"message":"You Can't train a model"});
  //     //  });
  //     this.fileLLMformData.append("title", this.uploadFileForm.value['title']);

  //     if (this.isSelectedDoc['model_type'] === 1) {
  //       //Bharthi llm

  //       const trainFormData = new FormData();

  //       this.fileLLMformData.forEach((value, key) => {
  //         trainFormData.append(key, value);
  //       });

  //       trainFormData.append("document_type", "standard");
  //       trainFormData.append("mode", "assessment");

  //       this.llmService.llmsearchAndQAUpload(this.fileLLMformData).subscribe({
  //           next: (response: any) => {
  //             console.log(response);

  //             if (response.hasOwnProperty("document_id")) {
  //               console.log(response["document_id"]);

  //               this.llmfile_uuid = response["document_id"];
  //               this.is_trainned_success = true;
  //               this.summarization = response['summary'];
  //               this.summary_category = response['categorization'];
  //               this.summary_metadata = response['extracted_metadata'];
  //               console.log(this.summary_category);
  //               this.newLessonCreate();
  //               // this.alert.showAlertMessage({"message":"LLM Model Trained Successfully"});
  //               console.log(this.summary_category);

  //               /*  const payLoad = {
  //                   group_id:parseInt(this.group_id),
  //                   message_id: this.message_id,
  //                     is_llm_training:true,
  //                   llmfile_uuid:this.llmfile_uuid
  //               }
  //               this.chatService.updateUploadFileData(payLoad).subscribe(
  //                 (response) => {
  //                   const payLoad = {
  //                   offset: this.OFFSET,
  //                   limit: this.RECORD_LIMIT,
  //                   groupId: this.group_id
  //                   }
  //                     this.elibraryDetailsComponent.getMessageAttchmentList(payLoad);
  //               }); */
  //             } else {
  //               this.isTrainingLLM = false;
  //               this.is_trainned_success = false;
  //               this.alert.showAlertMessage({ "message": "You Can't train a model" });
  //             }
  //           },
  //           error: (error: HttpErrorResponse) => {
  //             this.isTrainingLLM = false;
  //             this.is_trainned_success = false;
  //             this.alert.showAlertMessage({ "message": "You Can't train a model" });
  //           }
  //         });

  //     } else {
  //       //Devkhiran

  //       const trainFormData = new FormData();

  //       this.fileLLMformData.forEach((value, key) => {
  //         trainFormData.append(key, value);
  //       });

  //       trainFormData.append("document_type", "standard");
  //       trainFormData.append("mode", "assessment");

  //       this.llmService.llmTrainDoc(trainFormData).subscribe({
  //         next: (response: any) => {
  //           if (response.hasOwnProperty("uuid")) {
  //             this.llmfile_uuid = response["uuid"];
  //             this.generateAIQuest = response['uuid'];
  //             this.is_trainned_success = true;
  //             this.summarization = response['summary'];
  //             this.newLessonCreate();
  //             // this.alert.showAlertMessage({"message":"LLM Model Trained Successfully"});

  //             /*  const payLoad = {
  //                 group_id:parseInt(this.group_id),
  //                 message_id: this.message_id,
  //                   is_llm_training:true,
  //                 llmfile_uuid:this.llmfile_uuid
  //             }
  //             this.chatService.updateUploadFileData(payLoad).subscribe(
  //               (response) => {
  //                 const payLoad = {
  //                 offset: this.OFFSET,
  //                 limit: this.RECORD_LIMIT,
  //                 groupId: this.group_id
  //                 }
  //                   this.elibraryDetailsComponent.getMessageAttchmentList(payLoad);
  //             }); */
  //           } else {
  //             this.isTrainingLLM = false;
  //             this.is_trainned_success = false;
  //             this.alert.showAlertMessage({ "message": "You Can't train a model" });
  //           }
  //         },
  //         error: (error: HttpErrorResponse) => {
  //           this.isTrainingLLM = false;
  //           this.is_trainned_success = false;
  //           this.alert.showAlertMessage({ "message": "You Can't train a model" });
  //         }
  //       });
  //     }

  //   } else {
  //     this.showBtnSpinner = false;
  //     this.isTrainingLLM = true;
  //     this.newLessonCreate();

  //   }

  // }

  // StepFormLLM() {

  //   if (
  //     this.trainLLM &&
  //     this.fileLLMformData.get("file") &&
  //     this.fileLLMformData.get("class_id") &&
  //     (this.userRole == 1 || this.userRole == 2)
  //   ) {

  //     this.showBtnSpinner = true;
  //     this.isTrainingLLM = true;

  //     this.fileLLMformData.append("title", this.uploadFileForm.value['title']);

  //     const trainFormData = new FormData();

  //     this.fileLLMformData.forEach((value, key) => {
  //       trainFormData.append(key, value);
  //     });

  //     trainFormData.append("document_type", "standard");
  //     trainFormData.append("mode", "assessment");

  //     this.llmService.llmTrainDoc(trainFormData).subscribe({

  //       next: (response: any) => {

  //         if (!response) {
  //           this.handleTrainError();
  //           return;
  //         }

  //         // -------- Model Type 1 (Bharthi LLM) --------
  //         if (this.isSelectedDoc?.model_type === 1) {

  //           this.generateAIQuest = response?.uuid;

  //           this.llmService.llmsearchAndQAUpload(this.fileLLMformData).subscribe({

  //             next: (uploadRes: any) => {

  //               if (uploadRes?.document_id) {

  //                 this.llmfile_uuid = uploadRes.document_id;
  //                 this.is_trainned_success = true;

  //                 this.summarization = uploadRes?.summary;
  //                 this.summary_category = uploadRes?.categorization;
  //                 this.summary_metadata = uploadRes?.extracted_metadata;

  //                 this.newLessonCreate();

  //               } else {
  //                 this.handleTrainError();
  //               }
  //             },

  //             error: () => {
  //               this.handleTrainError();
  //             }

  //           });

  //         }

  //         // -------- Model Type 2 (Devkhiran) --------
  //         else {

  //           if (response?.uuid) {

  //             this.llmfile_uuid = response.uuid;
  //             this.generateAIQuest = response.uuid;
  //             this.is_trainned_success = true;

  //             this.summarization = response?.summary;

  //             this.newLessonCreate();

  //           } else {
  //             this.handleTrainError();
  //           }

  //         }

  //       },

  //       error: () => {
  //         this.handleTrainError();
  //       }

  //     });

  //   } else {

  //     this.showBtnSpinner = false;
  //     this.isTrainingLLM = true;
  //     this.newLessonCreate();

  //   }

  // }

  StepFormLLM() {

    if (
      this.trainLLM &&
      this.fileLLMformData.get("file") &&
      this.fileLLMformData.get("class_id") &&
      (this.userRole == 1 || this.userRole == 2)
    ) {

      this.showBtnSpinner = true;
      this.isTrainingLLM = true;

      this.fileLLMformData.append("title", this.uploadFileForm.value['title']);

      const trainFormData = new FormData();

      this.fileLLMformData.forEach((value, key) => {
        trainFormData.append(key, value);
      });

      trainFormData.append("document_type", "standard");
      trainFormData.append("mode", "assessment");


      // ========================
      // Bharathi LLM
      // ========================
      if (this.isSelectedDoc['model_type'] === 1) {

        this.llmService.llmsearchAndQAUpload(this.fileLLMformData).subscribe({

          next: (response: any) => {

            console.log(response);
            this.isUploadDocLoader = false;

            if (response?.document_id) {

              this.llmfile_uuid = response.document_id;
              this.is_trainned_success = true;

              this.summarization = response.summary;
              this.summary_category = response.categorization;
              this.summary_metadata = response.extracted_metadata;

              this.newLessonCreate();

            } else {

              this.handleTrainError();

            }

          },

          error: () => {
            this.handleTrainError();
          }

        });

      }
      // ========================
      // Bharathi LLM
      // ========================

      else if (this.isSelectedDoc['model_type'] === 3) {

        this.llmService.llmsearchAndQAUpload(this.fileLLMformData).subscribe({

          next: (response: any) => {

            console.log(response);

            if (response?.document_id) {

              this.llmfile_uuid = response.document_id;
              this.is_trainned_success = true;

              this.isUploadDocLoader = false;

              this.summarization = response.summary;
              this.summary_category = response.categorization;
              this.summary_metadata = response.extracted_metadata;

              this.newLessonCreate();

            } else {

              this.handleTrainError();

            }

          },

          error: () => {
            this.handleTrainError();
          }

        });
      }

      // ========================
      // Devkhiran LLM
      // ========================
      else {

        this.llmService.llmTrainDoc(trainFormData).subscribe({

          next: (response: any) => {

            if (response?.uuid) {

              this.isUploadDocLoader = false;

              this.llmfile_uuid = response.uuid;
              this.generateAIQuest = response.uuid;
              this.is_trainned_success = true;

              this.summarization = response.summary;

              this.newLessonCreate();

            } else {

              this.handleTrainError();

            }

          },

          error: () => {
            this.handleTrainError();
          }

        });

      }

    }

    else {

      this.showBtnSpinner = false;
      this.isTrainingLLM = true;
      this.newLessonCreate();

    }

  }


  // ========================
  // Error Handler
  // ========================

  handleTrainError() {

    this.isTrainingLLM = false;
    this.showBtnSpinner = false;
    this.is_trainned_success = false;

    this.alert.showAlertMessage({
      message: "You Can't train a model"
    });

  }

  StepFormMove() {

    if (this.uploadFileForm.invalid) {
      this.uploadFileForm.markAllAsTouched();
      this.uploadFileForm.markAsDirty();
      if (this.uploadFileForm.controls['survey'].invalid || this.uploadFileForm.controls['polls'].invalid || this.uploadFileForm.controls['notes'].invalid) {
        this.alert.showAlertMessage({ "message": "Please fill required fields" });
        return true;

      }

    }

    if (this.stepperIndex < 4) {
      this.stepperIndex = this.stepperIndex + 1;
    }

    switch (this.stepperIndex) {
      case 1:
        this.activeTab = 'assessment';
        break;
      case 2:
        this.activeTab = 'survey';
        break;
      case 3:
        this.activeTab = 'poll';
        break;
      case 4:
        this.activeTab = 'notes';
    }

    console.log("steperindex", this.stepperIndex);
    let tabName = this.activeTab;
    var i, x, tablinks;
    x = document.getElementsByClassName("content-tab");
    for (i = 0; i < x.length; i++) {
      x[i].style.display = "none";
    }
    tablinks = document.getElementsByClassName("tab");
    for (i = 0; i < x.length; i++) {
      tablinks[i].className = tablinks[i].className.replace(" is-active", "");
    }
    document.getElementById(tabName).style.display = "flex";
    const myElement = document.getElementById(tabName);

    // Add a single class
    myElement.classList.add('is-active');
    tablinks[this.stepperIndex].className = tablinks[this.stepperIndex].className + " is-active";
  }


  newLessonCreate() {

    if (this.stepperIndex == 0) {
      console.log(this.summary_category);
      const formFields: any = {
        fieldName: null,
        activity: null,
        to_user_id: null,
        group_id: null,
        message: null,
      };

      //this.showBtnSpinner = true;
      let data = this.uploadFileForm.value;


      if (data.assessment.length > 0) {
        this.is_question_found = true;
      }
      if (data.survey.length > 0) {
        this.is_survey_found = true;
      }

      if (data.polls.length > 0) {
        this.is_polls_found = true;
      }

      const userid = parseInt(window.localStorage.getItem('user_id'))

      const classList = this.selectedClassList.filter(x => x !== userid)

      const lessonPrice = parseFloat(data.price);
      const lessondiscount = parseInt(data.discount);

      let randomqustNo = parseInt(data.random_question)

      const existFileList = [...this.appComponent.selectedFilesList];
      let fileIndex = null;
      formFields.message = data.title;
      formFields.assessment = JSON.stringify(data.assessment);
      formFields.survey = JSON.stringify(data.survey);
      formFields.polls = JSON.stringify(data.polls);
      formFields.notes = JSON.stringify(data.notes);
      formFields.is_download = data.download_link;
      formFields.price = lessonPrice ? lessonPrice : 0;
      formFields.discount = lessondiscount ? lessondiscount : 0;
      formFields.water_mark_title = data.watermark_title;
      formFields.description = data.description;
      formFields.duration = data.duration;
      formFields.fieldName = 'group_gallery';
      formFields.activity = 'groupChatMessage';
      formFields.is_question_found = this.is_question_found;
      formFields.is_publish = data.publish;
      formFields.is_survey_found = this.is_survey_found;
      formFields.is_polls_found = this.is_polls_found;
      formFields.is_notes_found = this.is_notes_found;
      formFields.group_id = this.group_id;
      formFields.chat_user_list = classList;
      formFields.min_percentage = data.min_percentage;
      formFields.is_allow_retest = data.is_allow_retest ? data.is_allow_retest : false;
      formFields.random_question = randomqustNo ? randomqustNo : 0;
      formFields["is_llm_training"] = this.llmfile_uuid ? true : false;
      if (this.trainLLM) {
        formFields['summary'] = this.summarization;
        formFields['llmfile_uuid'] = this.llmfile_uuid;
        formFields['summary_category'] = JSON.stringify(this.summary_category) || [];
        formFields.summary_category = JSON.stringify(this.summary_category)
        formFields['summary_metadata'] = JSON.stringify(this.summary_metadata) || {};
        formFields.summary_metadata = JSON.stringify(this.summary_metadata) || {};

      } else {
        formFields['summary'] = "";
        formFields['llmfile_uuid'] = "";
      }

      if (this.message_id) {
        formFields["message_id"] = this.message_id;
      }
      fileIndex = existFileList.findIndex(el => el.group_id === this.group_id);
      if (fileIndex >= 0) {
        existFileList.splice(fileIndex, 1);
      }

      this.appComponent.selectedFilesList = existFileList;
      this.fileUploadingInProgress = true;
      this.showBtnSpinner = true;
      //this.isTrainingLLM = true;
      formFields['is_doc_section'] = true;
      this.appComponent.fileUploadWithProgess(formFields, this.upLoadedFileList).then((fileList: any): void => {
        console.log("fileList", fileList)
        this.message_id = fileList[0]['message_id'];
        this.showBtnSpinner = false;
        this.isTrainingLLM = false;



        const newData = {
          created_at: fileList[0].day,
          download_url: fileList[0].download_file_path,
          file_ext: fileList[0].file_ext,
          file_id: fileList[0].file_id,
          file_path: 'temp',
          file_size: fileList[0].file_size,
          file_type: fileList[0].file_type,
          message: fileList[0].message,
          message_id: fileList[0].message_id,
          message_type: fileList[0].message_type,
          shared_by: fileList[0].first_name,
          thumb_Url: fileList[0].thumb_file_path,
          view_Url: fileList[0].view_Url,
          is_question_found: fileList[0].is_question_found,
          is_survey_found: fileList[0].is_survey_found,
          is_polls_found: fileList[0].is_polls_found,
          is_download: fileList[0].is_download,
          price: fileList[0].price,
          discount: fileList[0].discount,
          duration: fileList[0].duration,
          is_publish: fileList[0].is_publish,
          water_mark_title: fileList[0].water_mark_title,
          read_user_ids: fileList[0].read_user_ids,
          is_llm_training: fileList[0]['is_llm_training'],
          summary: fileList[0]['summary'],
          llmfile_uuid: fileList[0]['llmfile_uuid'],
          is_doc_section: fileList[0]['is_doc_section'],
          summary_category: fileList[0]['summary_category'],
          summary_metadata: fileList[0]['summary_category']
        }
        //this.Lesson_responseData=newData;
        const copyList = [...this.elibraryDetailsComponent.getElibraryFileList];
        const mergeData = [newData, ...copyList];
        this.elibraryDetailsComponent.getElibraryFileList = mergeData;

        if (this.trainLLM && this.is_trainned_success) {
          this.alert.showAlertMessage({ "message": "LLM Model Trained Successfully" });
        }

        this.confirmDialogService.openConfirmDialog('', {
          title: 'Confirmation',
          message: 'Do you want to generate assessment?',
          btnOkText: 'YES',
          btnCancelText: 'NO',
          onClose: (data: any) => {
            if (data) {
              this.StepFormMove();
            } else {
              const elibraryCount = {
                count: 1,
                group_id: this.group_id
              };
              this.onElibraryCountUpdate.emit(elibraryCount);
              this.dataSharingService.emitLessonCount(elibraryCount);
              this.httpLoader.hideLoader();
              this.alert.showAlertMessage({ "message": "Document uploaded successfully." });
              this.showBtnSpinner = false;
              this.is_question_found = false;
              this.is_survey_found = false;
              this.is_survey_found = false;
              this.uploadFileForm.reset();
              this.elibraryComponent.getElibrary(0);
              this.elibraryDetailsComponent.domElementControl.showCreateElibrary = false;
              this.elibraryDetailsComponent.activeFileUpload = false;
              this.elibraryDetailsComponent.activeTileView = true;
              this.elibraryDetailsComponent.activeFileUploadHeader = false;
              this.elibraryComponent.viewLibraryList = false;
            }
          }
        });
      }, (error: HttpErrorResponse) => {
        this.showBtnSpinner = false;
      });
    } else {

      if (this.uploadFileForm.invalid) {
        this.uploadFileForm.markAllAsTouched();
        this.uploadFileForm.markAsDirty();
        if (this.uploadFileForm.controls['survey'].invalid || this.uploadFileForm.controls['polls'].invalid || this.uploadFileForm.controls['notes'].invalid) {
          this.alert.showAlertMessage({ "message": "Please fill required fields" });
          return true;

        }
      }

      let payLoad = this.uploadFileForm.value;


      if (payLoad.assessment.length > 0) {
        this.is_question_found = true;

        let assessmentLength = payLoad["assessment"];

        for (let i = 0; i < assessmentLength.length; i++) {
          const el = assessmentLength[i];

          if (el.answer_type === "choice") {
            var checked = false;
            for (let k = 0; k < el.answer.length; k++) {
              const checker = el.answer[k];

              if (el.mark !== null && checker.is_correct_answer !== false) {
                checked = true;
              }
            }

            if (!checked) {
              this.alert.showAlertMessage({
                message:
                  "Please check Assessment question answers and select any answer",
              });
              // this.markOptions[i] = true;
              this.showBtnSpinner = false;
              return false;
            }
          } else {
            if (el.answer_type !== null) {
              checked = true;
            }

            if (!checked) {
              this.alert.showAlertMessage({
                message:
                  "Please check Assessment question answers and select any answer",
              });

              this.showBtnSpinner = false;
              return false;
            }
          }
        }

        if (
          payLoad["random_question"] === "" ||
          payLoad["random_question"] == 0
        ) {
          this.showBtnSpinner = false;
          this.httpLoader.hideLoader();
          this.alert.showAlertMessage({
            message: "Please enter random question number value.",
          });
          return false;
        } else if (payLoad["random_question"] > assessmentLength.length) {
          this.showBtnSpinner = false;
          this.httpLoader.hideLoader();
          this.alert.showAlertMessage({
            message:
              "Please check Random question limit. Based on create assessment question",
          });
          return false;
        }

      } else {
        payLoad["random_question"] = 0;
      }
      if (payLoad.survey.length > 0) {
        this.is_survey_found = true;
      }

      if (payLoad.polls.length > 0) {
        this.is_polls_found = true;
      }



      let price = payLoad["price"] ? payLoad["price"] : 0;
      let discount = payLoad["discount"] ? payLoad["discount"] : 0;

      const userid = parseInt(window.localStorage.getItem("user_id"));

      const classList = this.selectedClassList.filter((x) => x !== userid);

      payLoad["group_id"] = parseInt(this.group_id);
      payLoad["message_id"] = this.message_id;
      payLoad["is_question_found"] = this.is_question_found;
      payLoad["is_survey_found"] = this.is_survey_found;
      payLoad["is_polls_found"] = this.is_polls_found;
      payLoad["is_notes_found"] = this.is_notes_found;
      payLoad["discount"] = parseInt(discount);
      payLoad["price"] = parseFloat(price);
      payLoad["chat_user_list"] = classList;
      payLoad["is_allow_retest"] = this.isAllowRetest;
      payLoad["is_llm_training"] = this.trainLLM;
      if (this.trainLLM) {
        payLoad['summary'] = this.summarization;
        payLoad['llmfile_uuid'] = this.llmfile_uuid;
      } else {
        payLoad['summary'] = "";
        payLoad['llmfile_uuid'] = "";
      }


      this.showBtnSpinner = true;
      this.chatService.updateUploadFileData(payLoad).subscribe(
        (response) => {
          this.showBtnSpinner = false;
          if (this.stepperIndex == 4) {
            console.log("response done", response);
            /*  let fileList:any=[];
                   fileList.push(response['record']);
                const newData = {
                      created_at: fileList[0].day,
                      download_url: fileList[0].download_file_path,
                      file_ext: fileList[0].file_ext,
                      file_id: fileList[0].file_id,
                      file_path: 'temp',
                      file_size: fileList[0].file_size,
                      file_type: fileList[0].file_type,
                      message: fileList[0].message,
                      message_id: fileList[0].message_id,
                      message_type: fileList[0].message_type,
                      shared_by: fileList[0].first_name,
                      thumb_Url: fileList[0].thumb_file_path,
                      view_Url: fileList[0].view_Url,
                      is_question_found: fileList[0].is_question_found,
                      is_survey_found: fileList[0].is_survey_found,
                      is_polls_found: fileList[0].is_polls_found,
                      is_download: fileList[0].is_download,
                      price: fileList[0].price,
                      discount: fileList[0].discount,
                      duration: fileList[0].duration,
                      is_publish: fileList[0].is_publish,
                      water_mark_title: fileList[0].water_mark_title,
                      read_user_ids:fileList[0].read_user_ids,
                      is_llm_training:fileList[0]['is_llm_training'],
                      llmfile_uuid:this.llmfile_uuid,
                      summary:this.summarization
                    }
                    const copyList = [...this.elibraryDetailsComponent.getElibraryFileList];
                    const mergeData = [newData, ...copyList];
                    this.elibraryDetailsComponent.getElibraryFileList = mergeData;  */
            const elibraryCount = {
              count: 1,
              group_id: this.group_id
            };
            this.onElibraryCountUpdate.emit(elibraryCount);
            this.dataSharingService.emitLessonCount(elibraryCount);
            this.httpLoader.hideLoader();
            this.alert.showAlertMessage({ "message": "Document uploaded successfully." });
            this.showBtnSpinner = false;
            this.is_question_found = false;
            this.is_survey_found = false;
            this.is_survey_found = false;
            this.uploadFileForm.reset();
            this.elibraryComponent.getElibrary(0);
            this.elibraryDetailsComponent.domElementControl.showCreateElibrary = false;
            this.elibraryDetailsComponent.activeFileUpload = false;
            this.elibraryDetailsComponent.activeTileView = true;
            this.elibraryDetailsComponent.activeFileUploadHeader = false;
            this.elibraryComponent.viewLibraryList = false;
          } else {
            this.StepFormMove();
          }


          // console.log("response",response);
        }, (error: HttpErrorResponse) => {
          this.showBtnSpinner = false;
        });
    }

  }


  SaveLesson() {



    if (this.uploadFileForm.invalid) {
      this.uploadFileForm.markAllAsTouched();
      this.uploadFileForm.markAsDirty();
      if (this.uploadFileForm.controls['survey'].invalid || this.uploadFileForm.controls['polls'].invalid || this.uploadFileForm.controls['notes'].invalid) {
        this.alert.showAlertMessage({ "message": "Please fill required fields" });
        return true;

      }
    }

    let payLoad = this.uploadFileForm.value;


    if (payLoad.assessment.length > 0) {
      this.is_question_found = true;

      let assessmentLength = payLoad["assessment"];

      for (let i = 0; i < assessmentLength.length; i++) {
        const el = assessmentLength[i];

        if (el.answer_type === "choice") {
          var checked = false;
          for (let k = 0; k < el.answer.length; k++) {
            const checker = el.answer[k];

            if (el.mark !== null && checker.is_correct_answer !== false) {
              checked = true;
            }
          }

          if (!checked) {
            this.alert.showAlertMessage({
              message:
                "Please check Assessment question answers and select any answer",
            });
            // this.markOptions[i] = true;
            this.showBtnSpinner = false;
            return false;
          }
        } else {
          if (el.answer_type !== null) {
            checked = true;
          }

          if (!checked) {
            this.alert.showAlertMessage({
              message:
                "Please check Assessment question answers and select any answer",
            });

            this.showBtnSpinner = false;
            return false;
          }
        }
      }

      if (
        payLoad["random_question"] === "" ||
        payLoad["random_question"] == 0
      ) {
        this.showBtnSpinner = false;
        this.httpLoader.hideLoader();
        this.alert.showAlertMessage({
          message: "Please enter random question number value.",
        });
        return false;
      } else if (payLoad["random_question"] > assessmentLength.length) {
        this.showBtnSpinner = false;
        this.httpLoader.hideLoader();
        this.alert.showAlertMessage({
          message:
            "Please check Random question limit. Based on create assessment question",
        });
        return false;
      }

    } else {
      payLoad["random_question"] = 0;
    }
    if (payLoad.survey.length > 0) {
      this.is_survey_found = true;
    }

    if (payLoad.polls.length > 0) {
      this.is_polls_found = true;
    }



    let price = payLoad["price"] ? payLoad["price"] : 0;
    let discount = payLoad["discount"] ? payLoad["discount"] : 0;

    const userid = parseInt(window.localStorage.getItem("user_id"));

    const classList = this.selectedClassList.filter((x) => x !== userid);

    payLoad["group_id"] = parseInt(this.group_id);
    payLoad["message_id"] = this.message_id;
    payLoad["is_question_found"] = this.is_question_found;
    payLoad["is_survey_found"] = this.is_survey_found;
    payLoad["is_polls_found"] = this.is_polls_found;
    payLoad["is_notes_found"] = this.is_notes_found;
    payLoad["discount"] = parseInt(discount);
    payLoad["price"] = parseFloat(price);
    payLoad["chat_user_list"] = classList;
    payLoad["is_allow_retest"] = this.isAllowRetest;
    payLoad["is_llm_training"] = this.trainLLM;
    if (this.trainLLM) {
      payLoad['summary'] = this.summarization;
      payLoad['llmfile_uuid'] = this.llmfile_uuid;
    } else {
      payLoad['summary'] = "";
      payLoad['llmfile_uuid'] = "";
    }


    this.showBtnSpinner = true;
    this.chatService.updateUploadFileData(payLoad).subscribe(
      (response) => {
        this.showBtnSpinner = false;

        console.log("response done", response);

        const elibraryCount = {
          count: 1,
          group_id: this.group_id
        };
        this.onElibraryCountUpdate.emit(elibraryCount);
        this.dataSharingService.emitLessonCount(elibraryCount);
        this.httpLoader.hideLoader();
        this.alert.showAlertMessage({ "message": "Document uploaded successfully." });
        this.showBtnSpinner = false;
        this.is_question_found = false;
        this.is_survey_found = false;
        this.is_survey_found = false;
        this.uploadFileForm.reset();
        this.elibraryComponent.getElibrary(0);
        this.elibraryDetailsComponent.domElementControl.showCreateElibrary = false;
        this.elibraryDetailsComponent.activeFileUpload = false;
        this.elibraryDetailsComponent.activeTileView = true;
        this.elibraryDetailsComponent.activeFileUploadHeader = false;
        this.elibraryComponent.viewLibraryList = false;

      }, (error: HttpErrorResponse) => {
        this.showBtnSpinner = false;
      });


  }



}
